import { render, staticRenderFns } from "./userTreaty.vue?vue&type=template&id=61a526a6&scoped=true&"
import script from "./userTreaty.vue?vue&type=script&lang=js&"
export * from "./userTreaty.vue?vue&type=script&lang=js&"
import style0 from "./userTreaty.vue?vue&type=style&index=0&id=61a526a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a526a6",
  null
  
)

export default component.exports